import { useQuery } from 'react-query';

//APP
import { api } from '../../../api';
import { localConfig } from '../../../../Configs/localConfig';
import { errorAlert } from '../../../../utils/alert';

//=================================================================================>
// BUSCAR LISTA DE AGRUPAMENTOS DE TALHÕES
//<=================================================================================

//TYPES
export type AgrupamentoTalhao__Item = {
    cod: number | null,
    cod_conta: number | null,
    cod_cliente: number | null,
    cod_propriedade: number | null,
    cod_safra: number | null,
    status: number | null,
    create_time: string | null,
    update_time: string | null,
    delete_time: string | null,
    nome: string | null,
    create_user: string | null,
    update_user: string | null,
    delete_user: string | null,
    propriedade_nome: string | null,
    area_total: string | null,
    talhao: {
        cod: number | null,
        cod_talhao_grupo: number | null,
        cod_talhao: number | null,
        talhao_nome: string | null,
        talhao_area: string | null,
        talhao_kml: { nome: string | null, lookAt: { latitude: number | null, longitude: number | null }, coordenadas: { latitude: number | null, longitude: number | null }[] };
    }[]
}

//INTERFACE
export interface AgrupamentoTalhao {
    itens: AgrupamentoTalhao__Item[]
}

export const useGetAgrupamentoTalhoes = (cod_propriedade: number) => {
    let { conta, codCliente, codSafra } = localConfig();

    const queryKey: any = [`grupo-talhao_${conta}_${codCliente}_${codSafra}_${cod_propriedade}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AgrupamentoTalhao, Error>(queryKey, async () => {
        return api.get(`grupo-talhao?codConta=${conta}&codCliente=${codCliente}&codSafra=${codSafra}&codPropriedade=${cod_propriedade}&embed=talhao`)
            .then((response):any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de agrupamentos!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 50000
        }
    );

    return { 
        data_agrupamentos: data?.itens ?? [], 
        carregando_agrupamentos: isFetching, 
        refetch_data_agrupamentos: refetch,
        isFetched: isFetchedAfterMount,
        isError: isError
    };
};